<template>
    <div>
        <div class="row align-items-center">
            <div class="col-md-auto">
                <span>{{ imageLabel }}</span>
            </div>
            <div class="col">
                <div class="row text-center no-gutters justify-content-end">
                    <div class="btn-group" v-if="form.file">
                        <button class="btn btn-link text-danger" @click="form.file = null" type="button">
                            Delete
                        </button>
                        <button class="btn btn-link text-secondary" @click="preview = !preview" type="button">
                            <div v-if="!preview">Show Preview</div>
                            <div v-if="preview">Hide Preview</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-container d-flex align-items-center justify-content-center"
             v-if="!preview"
             :class="{'bordered': !preview, 'invalid-image': invalidImage}">
            <div class="text-center">
                <input hidden="hidden" type="file" accept="image/jpeg,image/png" :id="id" @change="upload"/>
                <label class="swell-upload text-primary" :for="id" v-if="!preview">
                    <span class="fa-stack fa-lg">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
                    </span><br/>
                    <span>{{ divLabel }}</span>
                </label>
            </div>
        </div>
        <div class="image-container" v-if="preview" :class="{'invalid-image': invalidImage}">
            <img class="align-self-center" :src="imageUrl" :alt="imageLabel"/>
        </div>
        <p class="text-center small" v-if="form.errors.has('file')" :class="{'invalid-feedback': invalidImage}">
            {{ form.errors.get('file') }}
        </p>
    </div>
</template>

<script>
    import _ from 'lodash';

    const ONE_MB = 1000000;

    export default {
        props: {
            imageLabel: {default: 'Image'},
            value     : [String],
            index     : Number,
            url       : String
        },

        data() {
            return {
                id          : Math.random().toString(36).substring(2),
                preview     : Boolean(this.value),
                invalidImage: false,
                form        : new Form({file: _.clone(this.value)}, 'multipart'),
            }
        },

        computed: {
            divLabel() {
                if (this.form.file) {
                    return this.form.file.name;
                }
                return 'Upload Image';
            },

            imageUrl() {
                if (typeof (this.form.file) === 'string') {
                    return this.url || this.form.file;
                }
                return URL.createObjectURL(this.form.file);
            }
        },

        methods: {
            upload(event) {
                this.form.file = event.target.files[0];
            },

            uploadServer() {
                this.form.post(this.$laroute.route('api.files.temp-image'))
                    .then(this.onUploadSuccess.bind(this))
                    .catch(this.onUploadFailed.bind(this));
            },

            onUploadSuccess({data}) {
                this.$emit('input', data.path);
            },

            onUploadFailed(response) {
                console.error('response - Error', response);
            },
        },

        watch: {
            'form.file': function (image) {
                this.preview      = Boolean(image);
                this.invalidImage = image && ((image.size / ONE_MB) > 2);
                image ? this.uploadServer() : this.$emit('input', null);
                image ? this.$emit('preview', this.imageUrl, this.index) : this.$emit('preview', null, this.index);
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/variables";

    img {
        max-width: 100%;
    }

    .image-container {
        border: transparent;
        border-style: dashed;
        border-radius: 0.5em;
        margin-right: .1em;
        margin-left: .1em;
        min-height: 240px;

        img {
            border-radius: 0.5em;
        }
    }

    .bordered {
        border-color: #e9e9e9;
    }

    .invalid-image {
        border-color: red;
    }

    .default-upload {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .swell-upload {
        cursor: pointer;
    }
</style>
